var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBack2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20V17.3333H13.4667C14.8667 17.3333 16.0833 16.8889 17.1167 16C18.15 15.1111 18.6667 14 18.6667 12.6667C18.6667 11.3333 18.15 10.2222 17.1167 9.33333C16.0833 8.44444 14.8667 8 13.4667 8H5.06667L8.53333 11.4667L6.66667 13.3333L0 6.66667L6.66667 0L8.53333 1.86667L5.06667 5.33333H13.4667C15.6222 5.33333 17.4722 6.03333 19.0167 7.43333C20.5611 8.83333 21.3333 10.5778 21.3333 12.6667C21.3333 14.7556 20.5611 16.5 19.0167 17.9C17.4722 19.3 15.6222 20 13.4667 20H4Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack2);
export default __webpack_public_path__ + "static/media/icon_back_2.57a71de6e8a167050f592c56d7eb467c.svg";
export { ForwardRef as ReactComponent };